import type { ChatUiBusStopOption } from '@voll-intelligence/genui-contract';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import { CardFooter } from '../../../shared/ui/card.js';
import { BLOCK_SHELL } from '../../../shared/ui/block_shell.js';
import './bus_stops.css';

/**
 * Seletor de rodoviária (`bus_stops`) — desambiguação de parada por TOQUE, no
 * lugar da lista numerada em texto. Card compacto: título localizado por `which`
 * (origem/destino) + uma linha tocável por candidata. O toque vira quick-reply
 * com o NOME EXATO da opção (`onPick`) — o agents casa por nome (exact-match)
 * contra as candidatas pendentes server-side; nenhum código viaja no wire.
 * `readOnly` (card congelado de turno anterior) desabilita os botões.
 *
 * A casca é a dos blocos da conversa (`BLOCK_SHELL`, #6321), a mesma do
 * checkout e dos cards da mobilidade; o layout e o espaçamento são utilitárias do DS. A cor e a
 * tipografia das opções seguem na folha legada até o design decidir.
 */
export function BusStopsPicker({
  which,
  options,
  note,
  readOnly = false,
  onPick,
}: {
  readonly which: 'origin' | 'destination';
  readonly options: ChatUiBusStopOption[];
  readonly note?: string;
  readonly readOnly?: boolean;
  readonly onPick: (name: string) => void;
}) {
  const { t } = useGenUiI18n();
  return (
    <div className={BLOCK_SHELL} aria-label={t('busStops.aria')}>
      <h4 className="bst-ttl m-0">
        {t(which === 'origin' ? 'busStops.titleOrigin' : 'busStops.titleDestination')}
      </h4>
      <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
        {options.map((o) => (
          <li key={o.name}>
            <button
              type="button"
              className="bst-opt min-h-11 w-full px-3 py-2.5 text-left"
              disabled={readOnly}
              onClick={() => {
                onPick(o.name);
              }}
            >
              {o.name}
            </button>
          </li>
        ))}
      </ul>
      <CardFooter note={note} />
    </div>
  );
}
